import FrequencyChartPresenter from "./Chart/ChartFrequencyPresenter";

export const Frequency = {
    Chart : FrequencyChartPresenter
}

export default Frequency;